import React from 'react'
import {Helmet} from "react-helmet"

export default props => {

    const title = props.title || ''
    const lang  = props.lang || ''
    const keywords = props.keywords || ''
    const description = props.description || ''
    const uri = (`${process.env.GATSBY_DOMAIN}/${lang}/${ props.slug !== undefined ? props.slug : '' }`).toLowerCase().trim()
    const logotipo = 'https://www.datocms-assets.com/34634/1600682635-logo.jpg'
    const image = props.image || logotipo
    const robotsValue = `${ process.env.GATSBY_DISABLEROBOTS}` === 'true' ? 'noindex' : 'index,follow'
    const phone = props.contactinfo.phone;
    const openingHours = props.contactinfo.opening.short;
    const page = props.page || null;

    return (
        <Helmet
          title='Eyewear Concept'
          titleTemplate={`${title} | %s`}
        >
            <html lang={lang} />
            <meta name="description" content={description || title} />
            <meta name="robots" content={robotsValue} />
            <meta name="author" content="Orienteed SLU" />
            <meta name="keywords" content={keywords} />

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Eyewear Concept" />
            <meta property="og:url" content={uri} />
            <meta property="og:title" content={`${title} | Eyewear Concept`} />
            <meta property="og:description" content={description || title} />
            <meta property="og:image" content={`${image}`} />
            <meta property="og:locale" content={lang} />

            <meta name="twitter:card" content="summary_large_image"/>
            <meta name="twitter:image" content={`${image}`}/>
            <meta name="twitter:site" content="@eyewearconcept"/>
            <meta name="twitter:creator" content="@eyewearconcept"/> 
            <meta name="twitter:title" content={`${title} | Eyewear Concept`} /> 
            <meta name="twitter:description" content={description || title} />
            
            <script type="application/ld+json">
                {
                    JSON.stringify({
                        "@context": "http://www.schema.org",
                        "@type": "LocalBusiness",
                        "name": "Eyewear Concept",
                        "legalName": "Optica Diagonal",
                        "email" : "info@eyewearconcept.com",
                        "url": "https://www.eyewearconcept.com",
                        "sameAs": [
                            "https://eyewearconcept.com"
                        ],
                        "logo": `https:${logotipo}`,
                        "image": `https:${logotipo}`,
                        "description": "",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "Rúa Papa Juan XXIII, 5",
                            "addressLocality": "Ourense",
                            "addressRegion": "Ourense",
                            "postalCode": "32003",
                            "addressCountry": "España"
                        },
                        "areaServed": {
                            "@type": "geoShape",
                            "addressCountry": "ES"
                        },
                        "geo": {
                            "@type": "GeoCoordinates",
                            "latitude": "42.340381",
                            "longitude": "-7.866249"
                        },
                        "hasMap": "",
                        "openingHours": [`${openingHours}`],
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "contactType": "Customer Care",
                            "telephone": `${phone}`
                        },
                        "telephone": `${phone}`
                    })
                }
            </script>

            {/* Self-referencig canonical */}
            {page && page > 2 ?
                <link rel='canonical' href={uri + "?page=" + page} />
                :
                <link rel='canonical' href={uri} />
            }
            {/* Preconnect hints */}
            <link rel="preconnect" href="https://app.snipcart.com"></link>
            <link rel="preconnect" href="https://cdn.snipcart.com"></link>
        </Helmet>
    )
}